import ExportedImage from 'next-image-export-optimizer'
import Link from 'next/link'
import { useState } from 'react'

import { Button } from '@/components/atoms/ui/button'

import { cn } from '@/lib/utils'

interface ArticleCardProps {
  title: string
  image: string
  category: string
  uid: string
  language?: 'id' | 'en'
}

export const ArticleCard = ({ title, image, category, uid, language = 'id' }: ArticleCardProps) => {
  const [loading, setLoading] = useState(true)

  return (
    <Link href={`/${encodeURIComponent(uid)}`}>
      <figure className="flex items-center w-full h-32 gap-4 overflow-hidden sm:h-full sm:gap-0 sm:items-start sm:flex-col rounded-xl group">
        <div
          className={cn(
            'w-5/12 sm:w-full h-[98px] sm:h-[190px] relative overflow-hidden rounded-xl sm:rounded-b-none sm:rounded-t-xl',
            loading && 'animate-pulse bg-gray-500'
          )}
        >
          <ExportedImage
            priority={false}
            onLoad={() => setLoading(false)}
            src={image}
            sizes="200px"
            alt={'Gambar artikel ' + title}
            fill
            className="object-cover transition-all duration-300 group-hover:scale-105 group-hover:opacity-80"
          />
        </div>
        <figcaption className="h-full w-7/12 sm:w-full sm:h-[220px] flex flex-col justify-between sm:px-4 py-5 space-y-4 bg-white sm:border border-gray-300 sm:rounded-b-xl">
          <div className="space-y-1 sm:space-y-4">
            <span className="text-xs font-medium sm:text-sm text-primary-blue line-clamp-1">{category}</span>
            <h3 className="font-bold sm:text-xl line-clamp-3">{title}</h3>
          </div>
          <Button variant="secondary" className="hidden w-[140px] text-sm font-semibold sm:block">
            {language === 'en' ? 'Read More' : 'Selengkapnya'}
          </Button>
        </figcaption>
      </figure>
    </Link>
  )
}
